import { render } from "./Receipt.vue?vue&type=template&id=200a53d3"
import script from "./Receipt.vue?vue&type=script&lang=js"
export * from "./Receipt.vue?vue&type=script&lang=js"

import exportComponent from "/Users/nakarinjaiseengam/Photofair-STM-POS/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__